import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatLabel } from '@angular/material/form-field';

import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-add-universite',
    templateUrl: './modal-add-universite.component.html',
    styleUrls: ['./modal-add-universite.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatDialogTitle, CdkScrollable, MatDialogContent, MatLabel, MatDialogActions, MatButton, MatDialogClose]
})
export class ModalAddUniversiteComponent implements OnInit {
    data = inject(MAT_DIALOG_DATA);
    dialogRef = inject<MatDialogRef<ModalAddUniversiteComponent>>(MatDialogRef);

    public form: FormGroup;
    public formSubmitAttempt: boolean;

    constructor() {}

    // ---------------------------------------------------
    // CREATE FORM
    //
    createForm() {
        this.form = new FormGroup({
            titre: new FormGroup<string>('', [Validators.required]),
        });
    }

    get titre() {
        return this.form.get('titre');
    }

    // ---------------------------------------------------
    // SAVE LABEL
    //
    prepareForSave() {
        this.formSubmitAttempt = true;
        if (this.form.valid) {
            const data = {
                titre: this.titre.value,
            };
            this.dialogRef.close(data);
        }
    }

    // ---------------------------------------------------
    // CANCEL FORM
    //
    public cancelForm() {
        this.formSubmitAttempt = false;
    }

    // ---------------------------------------------------
    // INIT
    //
    ngOnInit() {
        this.createForm();
    }
}
